import { MeResponse, UserInfo, UserDecodedToken } from "../types";

export const mapMeUser = (rawUserInfo: MeResponse, token: string): UserInfo => {
  const tokenDecoded = decodedToken(token);

  return {
    ...rawUserInfo,
    profile: {
      ...rawUserInfo.profile,
      permissions: tokenDecoded.permissions || [],
    },
    user: {
      ...rawUserInfo.user,
      group_id:
        tokenDecoded.accessGroups.length > 0 ? tokenDecoded.accessGroups[0] : 0,
      accessGroups: tokenDecoded.accessGroups,
    },
  };
};

export const decodedToken = (token: string): UserDecodedToken => {
  const decodedToken = JSON.parse(atob(token.split(".")[1]));

  return decodedToken as UserDecodedToken;
};
